import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, hasRole } = useAuth();

  if (user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="text-slate-500 text-sm" data-testid="auth-loading">Verificando sesión…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (roles && !hasRole(...roles)) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="text-slate-600 text-center" data-testid="forbidden">
          <div className="text-xl font-bold text-slate-900">Acceso denegado</div>
          <div className="text-sm mt-2">No tienes permisos para ver esta página.</div>
        </div>
      </div>
    );
  }

  return children;
}
